export const ScreenshotIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
  >
    <rect
      x='0.5'
      y='0.5'
      width='24'
      height='24'
      fill='white'
      fillOpacity='0.5'
      stroke='white'
      strokeDasharray='2 2'
    />
    <circle cx='13' cy='13' r='4' fill='white' />
  </svg>
);
